export default "__VITE_ASSET__CooimZvv__"